// extracted by mini-css-extract-plugin
export default {"menu-item":"ProfileMenuItem_menu-item__MEfHk","header":"ProfileMenuItem_header__zJm0+"};